import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Typography } from "@material-ui/core";

import { STATUS_MAP } from "../../../constants";
import { NO_DATA_TEXT } from "../../../../../constants";
import { COLORS } from "../../../../../theme/colors";
import { ShaDowBox } from "../../../../../components/boxes";
import { TenancyData } from "../../../../../components/parts";
import { formatDatetime, getData, nFormatter } from "../../../../../services";
import rentedImg from "../../../../../assets/images/icons/rented.svg";
import economicVacancyImg from "../../../../../assets/images/icons/economic-vacancy.svg";
import physicalVacancyImg from "../../../../../assets/images/icons/physical-vacancy.svg";

const imageSrc = {
  RENTED: rentedImg,
  ECONOMIC_VACANCY: economicVacancyImg,
  PHYSICAL_VACANCY: physicalVacancyImg,
};

const defaultResults = (unitSystem) => [
  {
    title: "Unit ID",
    value: NO_DATA_TEXT,
  },
  {
    title: "Current Status",
    value: NO_DATA_TEXT,
  },
  {
    title: "Area",
    value: 0,
    unit: unitSystem,
  },
  {
    title: "Unit's Meters",
    value: 0,
  },
  {
    title: "Missing Connection Docs",
    value: 0,
  },
];

export const TenancyDataInfo = ({ unit }) => {
  const { user } = useSelector((state) => state.auth);
  const [results, setResults] = useState(defaultResults(user?.unit_system));

  const getStatusDate = (unit) => {
    if (unit.tenancy_status === "RENTED") {
      return `Till ${formatDatetime(unit.leasing_end, "MMM D, YYYY")}`;
    } else if (unit.tenancy_status === "ECONOMIC_VACANCY") {
      return `Since ${formatDatetime(unit.economic_vacancy_since, "MMM D, YYYY")}`;
    }
    return `Est. completion: ${formatDatetime(unit.physical_vacancy_completion, "MMM D, YYYY")}`;
  };

  useEffect(() => {
    getData(`/praas/v2/buildings/${unit.building.id}/properties/units/${unit.id}/`, (unit) => {
      setResults([
        {
          title: "Unit ID",
          value: (
            <Typography component="span" variant="h3" noWrap>
              {unit.unit_id}
            </Typography>
          ),
        },
        {
          title: "Current Status",
          value: (
            <Typography
              component="span"
              variant="h3"
              style={{ color: unit.tenancy_status === "RENTED" ? COLORS.green : COLORS.red }}
            >
              {STATUS_MAP[unit.tenancy_status]}
            </Typography>
          ),
          status: unit.tenancy_status,
          description: getStatusDate(unit),
          image_src: imageSrc[unit.tenancy_status],
          image_style: {
            width: 36,
            height: 44,
          },
        },
        {
          title: "Area",
          value: nFormatter(unit.area),
          unit: user?.unit_system,
        },
        {
          title: "Unit's Meters",
          value: unit.smart_meter_count,
        },
        {
          title: "Missing Connection Docs",
          value: <span style={{ color: COLORS.red }}>{unit.missing_docs}</span>,
        },
      ]);
    });

    return () => setResults(defaultResults(user?.unit_system));
  }, []);

  return (
    <ShaDowBox>
      <TenancyData results={results} />
    </ShaDowBox>
  );
};
